import { IIconBase } from '..'

const searchIcon = ({
  color = '#7E84A3',
  height = 16,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.66665 13.9997C11.1644 13.9997 14 11.1641 14 7.66634C14 4.16854 11.1644 1.33301 7.66665 1.33301C4.16884 1.33301 1.33331 4.16854 1.33331 7.66634C1.33331 11.1641 4.16884 13.9997 7.66665 13.9997Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.6666 14.6663L13.3333 13.333'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default searchIcon
